import { useSelector } from 'react-redux';
import { deferTracking, sendGAEvent } from '@noths/polaris-client-google-analytics';

import { selectProduct } from 'src/redux/product/selectors';
import type { DeliveryInfoProps } from './DeliveryInfo';

export const useDeliveryInfo = (): DeliveryInfoProps => {
  const product = useSelector(selectProduct);

  return {
    deliveryInfo: product.shippingInfo || undefined,
    onVisible: () => {
      deferTracking(() =>
        sendGAEvent({
          event: 'custom_event',
          event_category: 'Delivery info',
          event_label: 'not set',
          event_action: 'Impression',
        }),
      );
    },
  };
};
